import type { AxiosError } from 'axios';
import type { CreatorPostAnalysis } from 'backend';
import { createQuery } from 'react-query-kit';

import { supabase } from '../../supabase-client';

type Response = CreatorPostAnalysis;
type Variables = { id: string };

export const usePostAnalysis = createQuery<Response, Variables, AxiosError>({
  queryKey: ['post-analysis'],
  fetcher: async ({ id }) => {
    const { data, error } = await supabase
      .from('creatorPostAnalyses')
      .select('*')
      .eq('postId', id)
      .single();

    if (error) throw error;
    return data;
  },
});
